<i18n lang="yaml">
en:
  loading_basic_data: Loading basic data
  waiting_for_backend: Connecting to CELUS server

# we use the English text for Czech on purpose - we do not want to accidentally show cs to
# English speakers.
cs:
  loading_basic_data: Loading basic data
  waiting_for_backend: Connecting to CELUS server
</i18n>

<template>
  <div>
    <div class="bootup-logo">
      <img
        :src="theme.current.value.dark ? logoLightText : logoDarkText"
        height="158"
        alt="CELUS Logo"
      />
    </div>
    <h1 class="bootup">Welcome to CELUS</h1>
    <LoaderWidget
      :text="$t(bootUpMessage)"
      height="300px"
      padding-top="80px"
      max-width="400px"
    ></LoaderWidget>
  </div>
</template>

<script>
import logoDarkText from "@/assets/celus-vertical-dark.svg";
import logoLightText from "@/assets/celus-plus-white-vertical-nobg.svg";
import LoaderWidget from "@/components/util/LoaderWidget";
import { mapState } from "vuex";
import { useTheme } from "vuetify";
export default {
  name: "BootUpWidget",

  components: { LoaderWidget },

  setup() {
    // white-text logo on dark themes, dark-text logo on light ones
    return { theme: useTheme(), logoDarkText, logoLightText };
  },

  computed: {
    ...mapState({
      backendReady: "backendReady",
      bootUpMessage: "bootUpMessage",
    }),
  },
};
</script>

<style scoped lang="scss">
h1.bootup {
  text-align: center;
  font-size: 48px;
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
}

div.bootup-logo {
  padding-top: 10vh;
  text-align: center;
}
</style>
